import CoinUpArrow from "@icons/coin-up-arrow.svg?react";
import EllipseGradient from "@icons/ellipse-gradient.svg?react";
import { DateTime } from "luxon";

type Props = {
  createdAt: string;
  title: string;
  body: string;
};

const Notification = ({ children }: React.PropsWithChildren) => {
  return (
    <div
      className="can-notification shadow-can-light-box gap-x-3 rounded-2xl bg-white p-4 font-sans"
      style={{
        display: "grid",
        gridTemplateAreas: "'icon content button' 'datetime datetime datetime'",
        gridTemplateColumns: "50px 5fr 1fr",
        gridTemplateRows: "auto auto",
      }}
    >
      {children}
    </div>
  );
};

const Button = (
  props: React.PropsWithChildren<
    Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, "className">
  >,
) => (
  <button
    className="hover:bg-can-silver-gray -mr-2 ml-auto shrink-0 self-center rounded-full p-2"
    style={{ gridArea: "button" }}
    {...props}
  ></button>
);

const Content = ({ children }: React.PropsWithChildren) => {
  return (
    <div className="flex flex-col" style={{ gridArea: "content" }}>
      {children}
    </div>
  );
};

const Icon = () => (
  <div
    className="grid place-content-center place-items-center"
    style={{ gridArea: "icon" }}
  >
    <EllipseGradient style={{ gridColumn: 1, gridRow: 1 }} />
    <CoinUpArrow
      className="[&_path]:fill-blue-50"
      style={{ gridColumn: 1, gridRow: 1 }}
    />
  </div>
);

const Title = ({ children }: React.PropsWithChildren) => (
  <h3 className="text-can-midnight-steel font-bold">{children}</h3>
);

const Body = ({ children }: React.PropsWithChildren) => (
  <p>
    <small>{children}</small>
  </p>
);

const CreatedAt = ({ children }: { children: DateTime }) => (
  <small className="text-right" style={{ gridArea: "datetime" }}>
    {children.toLocaleString(DateTime.DATETIME_SHORT)}
  </small>
);

Notification.Button = Button;
Notification.Content = Content;
Notification.CreatedAt = CreatedAt;
Notification.Icon = Icon;
Notification.Body = Body;
Notification.Title = Title;

export { Notification };
export type { Props };
